var map = {
	"./cercaPet (1).jpg": 3774,
	"./cercaPet (1).png": 4208,
	"./cercaPet (10).png": 6518,
	"./cercaPet (11).png": 556,
	"./cercaPet (2).png": 460,
	"./cercaPet (3).png": 7936,
	"./cercaPet (4).png": 4261,
	"./cercaPet (5).png": 2754,
	"./cercaPet (6).png": 8059,
	"./cercaPet (7).png": 8345,
	"./cercaPet (8).png": 2086,
	"./cercaPet (9).png": 5449
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 659;